'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "DirectionButton": "Polaris-SortButton-DirectionButton",
  "DirectionButton-active": "Polaris-SortButton-DirectionButton__DirectionButton--active"
};

exports.default = styles;
